import { ForgeAgent, ForgeAvatarBuilder } from "@supernova-studio/model";
import { z } from "zod";
export const DTOForgeAgent = ForgeAgent;
export const DTOForgeAvatarBuilder = ForgeAvatarBuilder;
export const DTOCreateForgeAgent = DTOForgeAgent.omit({ projectId: true });
export const DTOUpdateForgeAgent = DTOCreateForgeAgent.extend({
    id: z.string(),
});
export const DTOCreateForgeAgentResponse = z.object({
    agent: DTOForgeAgent,
});
export const DTOUGetForgeAgentResponse = z.object({
    agent: DTOForgeAgent.nullable(),
});
export const DTOUpdateForgeAgentResponse = z.object({
    agent: DTOForgeAgent.nullable(),
});
export const DTOForgeAgentsListResponse = z.object({
    agents: z.array(DTOForgeAgent),
});
export const DTODeleteForgeAgentResponse = z.object({
    ok: z.literal(true),
});
